import { NgModule } from '@angular/core';

import { MatButtonModule} from '@angular/material/button'
import { MatCardModule} from '@angular/material/card'
import { MatIconModule} from '@angular/material/icon'
import { MatInputModule} from '@angular/material/input'
import { MatListModule} from '@angular/material/list'
import { MatSelectModule} from '@angular/material/select'
import { MatTableModule} from '@angular/material/table'
import { MatToolbarModule} from '@angular/material/toolbar'
import { MatPaginatorModule, MatPaginatorIntl } from '@angular/material/paginator';
import { getEsPaginatorIntl } from './utility/es-paginator.intl';



const modules = [
  MatButtonModule,
  MatCardModule,
  MatInputModule,
  MatIconModule,
  MatListModule,
  MatSelectModule,
  MatPaginatorModule,
  MatTableModule,
  MatToolbarModule
];

@NgModule({
  imports: modules,
  providers: [
    { provide: MatPaginatorIntl, useValue: getEsPaginatorIntl() }
  ],
  exports: modules,
})
export class MaterialModule {}
